<template>
    <div class="wl-know-logistics">
        <div class="logistics-content clearfix">
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">物流X简介</span></h3>
            <div class="brief-introduction-content"> 
                <p> &nbsp;&nbsp;&nbsp;&nbsp; 2019年2月，国务院发布《国家职业教育改革实施方案》(通常称为“职教20条”)中提出从2019年开始，在职业院校、应用型本科高校启动“学历证书+若干职业技能等级证书”制度试点（通常称1+X证书制度试点）工作。物流专业作为首批试点专业，中国物流与采购协会根据教育部的安排，负责考核认证。</p>
                <p> &nbsp;&nbsp;&nbsp;&nbsp; 中国物流与采购联合会、全国物流标准化技术委员会根据《物流师国家职业标准》和相关的职业资格管理条例，通过对物流从业人员的职业资格进行客观公正、科学规范的评价和鉴定，对合格者授予相应级别的物流师职业资格证书。</p>
                <p> &nbsp;&nbsp;&nbsp;&nbsp; 国家劳动和社会保障部2005年劳社厅函81号文通知在全国开展物流师国家职业资格全国统一鉴定，该职业共设4个等级，合格者将获得国家劳动和社会保障部颁发的国家物流师职业资格证书，证书全国统一编号，网上注册登记管理，可在政府网站查询，全国范围通用，是业内唯一国家证书，具有法律效力，与我国有双边、多边关系的国家互认。</p>        
            </div>
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">物流师职业等级划分</span></h3>
            <div class="brief-introduction-content"> 
                <p>&nbsp;&nbsp;&nbsp;&nbsp;物流师资格证全称“物流师职业资格证书”。具有物流师职业资格的所有人员都将被加入物流人才库，供物流或相关企业进行人才交流或选聘。根据"物流师国家职业标准"的规定，分别设立：物流员（国家职业资格四级）、助理物流师（国家职业资格三级）、中级物流师（国家职业资格二级）和高级物流师（国家职业资格一级）四个等级，可以适应企业对不同层次人才的需求。</p>
            </div>
            <div class="logistics-grade-list clearfix">
                <div class="logistics-grade-con lf">
                    <div class="grade-hade">
                        <i class="wl-icon-zhiye"></i>
                        物流员（国家职业资格四级）
                    </div>
                    <div class="grade-skill-content">
                        <p> 物流员的工作内容与技能要求如下: </p>
                        <p> （1）物品采购：执行采购计划、联系供应商</p>
                        <p>（2）仓储管理：入库作业、装卸搬运作业、储存作业、盘点作业、出库作业、单证制作</p>
                        <p>（3）配送管理：实施配送作业、流通加工、单据作业</p>
                        <p>（4）运输管理：运输作业、处理运输单证</p>
                        <p>（5）生产物流管理：物料处理、在制品管理</p>
                        <p>（6）国际货运管理：揽货、国际海上运输单证制作、国际多式联运单证制作</p>
                        <p>（7）物流信息处理：采集物品信息、物品信息采集技术</p>
                    </div>
                </div>
                <div class="logistics-grade-con rh">
                    <div class="grade-hade">
                        <i class="wl-icon-zhiye"></i>
                        助理物流师（国家职业资格三级）
                    </div>
                    <div class="grade-skill-content">
                        <p> 物流员的工作内容与技能要求如下: </p>
                        <p> （1）物品采购：执行采购计划、联系供应商</p>
                        <p>（2）仓储管理：入库作业、装卸搬运作业、储存作业、盘点作业、出库作业、单证制作</p>
                        <p>（3）配送管理：实施配送作业、流通加工、单据作业</p>
                        <p>（4）运输管理：运输作业、处理运输单证</p>
                        <p>（5）生产物流管理：物料处理、在制品管理</p>
                        <p>（6）国际货运管理：揽货、国际海上运输单证制作、国际多式联运单证制作</p>
                        <p>（7）物流信息处理：采集物品信息、物品信息采集技术</p>
                    </div>
                </div>
                <div class="logistics-grade-con lf">
                    <div class="grade-hade">
                        <i class="wl-icon-zhiye"></i>
                        中级物流师（国家职业资格二级） 
                    </div>
                    <div class="grade-skill-content">
                        <p> 物流员的工作内容与技能要求如下: </p>
                        <p> （1）物品采购：执行采购计划、联系供应商</p>
                        <p>（2）仓储管理：入库作业、装卸搬运作业、储存作业、盘点作业、出库作业、单证制作</p>
                        <p>（3）配送管理：实施配送作业、流通加工、单据作业</p>
                        <p>（4）运输管理：运输作业、处理运输单证</p>
                        <p>（5）生产物流管理：物料处理、在制品管理</p>
                        <p>（6）国际货运管理：揽货、国际海上运输单证制作、国际多式联运单证制作</p>
                        <p>（7）物流信息处理：采集物品信息、物品信息采集技术</p>
                    </div>
                </div>
                <div class="logistics-grade-con rh">
                    <div class="grade-hade">
                        <i class="wl-icon-zhiye"></i>
                        高级物流师（国家职业资格一级）
                    </div>
                    <div class="grade-skill-content">
                        <p> 物流员的工作内容与技能要求如下: </p>
                        <p> （1）物品采购：执行采购计划、联系供应商</p>
                        <p>（2）仓储管理：入库作业、装卸搬运作业、储存作业、盘点作业、出库作业、单证制作</p>
                        <p>（3）配送管理：实施配送作业、流通加工、单据作业</p>
                        <p>（4）运输管理：运输作业、处理运输单证</p>
                        <p>（5）生产物流管理：物料处理、在制品管理</p>
                        <p>（6）国际货运管理：揽货、国际海上运输单证制作、国际多式联运单证制作</p>
                        <p>（7）物流信息处理：采集物品信息、物品信息采集技术</p>
                    </div>
                </div>
            </div>
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">物流从业人员职业能力等级证书样本</span></h3>
            <div class="wl-sample-list clearfix">
                <div class="sample-li-img lf">
                    <img :src="sample1" alt="">
                    <p class="sample-text">物流员</p>
                </div>
                <div class="sample-li-img rh">
                    <img :src="sample2" alt="">
                    <p class="sample-text">助理物流师</p>
                </div>
                <div class="sample-li-img lf">
                    <img :src="sample3" alt="">
                    <p class="sample-text">中级物流师</p>
                </div>
                <div class="sample-li-img rh">
                    <img :src="sample4" alt="">
                    <p class="sample-text">高级物流师</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            sample1: require('assets/images/wly.png'),
            sample2: require('assets/images/zlwls.png'),
            sample3: require('assets/images/zjwls.png'),
            sample4: require('assets/images/gjwls.png'),
        }
    },
    methods:{}
}
</script>
